import React from 'react';
import {
	AGENCY_PROJECT,
	PAGE_LANDING,
	PAGE_SERP_LIST,
	PROJECT_CAR,
	PROJECT_CRI,
	PROJECT_CSV,
	TC_EVENT_NAMES
} from './Constants';
import { useInputParams } from './InputParamsProvider';

const TCEventContext = React.createContext();

export function TCEventProvider({ children }) {
	const [RANKING, PRODUCT_NAME, DATA] = useInputParams();

	let PAGE = '';
	let SEARCH_FOR = '';
	let GEO_LOCATON_ENABLED = false;

	const setTCAppData = (page, searchFor, geoLocationEnabled) => {
		PAGE = page;
		SEARCH_FOR = searchFor;
		GEO_LOCATON_ENABLED = geoLocationEnabled;
	};

	const TCLog = (eventName, geoLocationEnabled, type, typeValue) => {
		trackEvent(
			getCompleteEventName(
				eventName,
				PAGE,
				SEARCH_FOR,
				geoLocationEnabled ? geoLocationEnabled : GEO_LOCATON_ENABLED,
				RANKING,
				PRODUCT_NAME,
				type,
				typeValue
			)
		);
	};

	return (
		<TCEventContext.Provider
			children={children}
			value={[TCLog, setTCAppData]}
		/>
	);
}

export function useTCLog() {
	return React.useContext(TCEventContext);
}

function getCompleteEventName(
	eventName,
	page,
	searchFor,
	geoLocationEnabled,
	ranking,
	product,
	type,
	typeValue
) {
	const eventDynamicPrefix = getEventDynamicPrefix(page, searchFor, product);

	if (
		(eventName === TC_EVENT_NAMES.USER_POSITION ||
			eventName === TC_EVENT_NAMES.SEARCH_ADDRESS) &&
		!geoLocationEnabled
	) {
		eventName = eventName + '_NO_GEOLOCAL';
	}

	if (
		(eventName === TC_EVENT_NAMES.USER_POSITION ||
			eventName === TC_EVENT_NAMES.SEARCH_ADDRESS) &&
		ranking
	) {
		eventName = 'PP_' + eventName;
	}

	if (type === 'search-address') {
		eventName = eventName + '_' + replaceAll(typeValue, ' ', '_');
	} else if (type === 'filter') {
		eventName = eventName + '_' + (typeValue ? 'ON' : 'OFF');
	}

	// if (eventName && eventName.trim() != '') {
	// 	trackEvent(eventDynamicPrefix + eventName);
	// }

	return eventDynamicPrefix + eventName;
}

function getEventDynamicPrefix(page, searchFor, ranking, product) {
	let eventDynamicPrefix = '';

	if (page === PAGE_LANDING) {
		eventDynamicPrefix = 'NoGeolocal_';
	} else {
		if (ranking) {
			eventDynamicPrefix = product + '_';
		} else if (searchFor === AGENCY_PROJECT) {
			eventDynamicPrefix = 'TabAgenzie_';
		} else if (searchFor === PROJECT_CAR) {
			eventDynamicPrefix = 'TabCarrozzerie_';
		} else if (searchFor === PROJECT_CRI) {
			eventDynamicPrefix = 'TabCristalliGrandine_';
		} else if (searchFor === PROJECT_CSV) {
			eventDynamicPrefix = 'TabCentriSalute_';
		}

		if (page === PAGE_SERP_LIST) {
			eventDynamicPrefix += 'Lista_';
		} else {
			eventDynamicPrefix += 'Mappa_';
		}
	}

	return eventDynamicPrefix;
}

function trackEvent(eventName) {
	if (typeof window.tc_events_global === 'function') {
		try {
			if (eventName) {
				window.tc_events_global(this, 'xt_click', {
					level_2_number: 'TrovaAgente',
					click_name: eventName,
					click_type: 'N'
				});
			}
		} catch (e) {
			console.log(e.message);
		}
	} else {
		console.log('FALLITO:', eventName);
	}
}

function replaceAll(str, find, replace) {
	return str.replace(
		new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
		replace
	);
}
